// Masterclass hero — gallery thumb switcher + selectable Vault bump. Deferred.
(function () {
  document.querySelectorAll('.mm-mch').forEach(function (root) {
    var main = root.querySelector('.mm-mch__main-img');
    root.querySelectorAll('.mm-mch__t').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.mm-mch__t').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.dataset.img;
        if (main && main.tagName === 'IMG' && src) {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = src;
        }
      });
    });

    // Selectable Vault bump: toggle the extra cart item + swap the CTA price
    var toggle = root.querySelector('[data-mm-bump-toggle]');
    if (!toggle) return;
    var bumpInputs = root.querySelectorAll('[data-mm-bump-id]');
    var priceBase = root.querySelector('[data-mm-price-base]');
    var priceCombined = root.querySelector('[data-mm-price-combined]');

    function sync() {
      var on = toggle.checked;
      bumpInputs.forEach(function (el) { el.disabled = !on; });
      if (priceBase) priceBase.hidden = on;
      if (priceCombined) priceCombined.hidden = !on;
    }
    toggle.addEventListener('change', sync);
    sync();
  });
})();
